import { baseApi } from "api/BaseApi";
import { getISOCurrentDate } from "utils/timeUtils";

import { Ear, EarCreationPayload, EarWithFiles } from "./ear.types";

const EAR_BASE_URL = "ear";

const buildEarFormData = ({
  ear,
  earFile,
  currentUser,
  productId,
}: EarCreationPayload): FormData => {
  const earData = new FormData();

  if (earFile.file) {
    //if ear file, we add to submitted data
    earData.append("attachments_file", earFile.file);
    earData.append("attachments_source_type", earFile.file_source_type);
    earData.append("attachments_uploaded", earFile.uploaded_on);
    earData.append("active", "true");
    earData.append("file_label", earFile.file_label);
    earData.append("file_display_name", "Entropy Assessment Report (EAR)");
    earData.append("private", "true");
  }

  earData.append("pid", productId);
  // @ts-ignore // TODO: remove once user types merged in
  earData.append("creator", currentUser.id);
  // @ts-ignore // TODO: remove once user types merged in
  earData.append("editor", currentUser.id);
  earData.append("entrydate", getISOCurrentDate());
  earData.append("status", "Draft");
  earData.append("apriori", ear.apriori.toString());
  earData.append("reqd", ear.reqd.toString());
  earData.append("blurba", ear.blurba);
  earData.append("just", ear.just);

  return earData;
};

const earApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getEarsAndFilesByProductId: build.query<EarWithFiles[], number>({
      query: (productId) => ({
        //TODO: I could probably clean this response up (files in particular) since we are only returning on product form and product form read only
        url: `${EAR_BASE_URL}/ears_and_files_by_product_id/`,
        params: {
          product_id: productId,
        },
        method: "GET",
      }),
    }),
    createEar: build.mutation<Ear, EarCreationPayload>({
      query: (body) => ({
        url: `${EAR_BASE_URL}/`,
        method: "POST",
        body: buildEarFormData(body),
      }),
    }),
    updateEar: build.mutation<Ear, { earid: string; body: Partial<Ear> }>({
      query: ({ earid, body }) => ({
        url: `${EAR_BASE_URL}/${earid}/`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteEar: build.mutation<Ear, { earid: number }>({
      query: ({ earid }) => ({
        url: `${EAR_BASE_URL}/${earid}/`,
        method: "DELETE",
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetEarsAndFilesByProductIdQuery,
  useCreateEarMutation,
  useUpdateEarMutation,
  useDeleteEarMutation,
} = earApi;
